import { Timestamp } from "firebase/firestore";

export const PodcastCollection = "podcasts";

export interface UserVotes {
  timestamp: number;
  userId: string;
  vote: number;
}

export interface Podcast {
  id: string;
  title: string;
  url: string;
  description: string | null;
  imageUrl: string | null;
  userVotes: UserVotes[];
  participants: string[];
  createdAt: Timestamp;
  updatedAt?: Timestamp;
  listedBy: string;
}
